import React from 'react';

import {
  Typography,
} from '@mui/material';

import {
  ChipField,
  ReferenceArrayField,
  ReferenceArrayInput,
  SelectArrayInput,
  SingleFieldList,
} from 'react-admin';

import ColoredChipField from './ColoredChipField';
import { useScopedEmbeddedViewContext } from '../components/utils/ScopedEmbeddedViewContext';
import EditFieldLayout from '../components/layout/EditFieldLayout';

export const ReferenceManyDisplayField = ({
  withColor,
  source,
  reference,
  sortable,
} : {
  withColor?: boolean;
  label?: string;
  source: string;
  reference: string;
  sortable?: boolean;
}) => {
  const scope = useScopedEmbeddedViewContext();
  const shouldLink = !scope.isScopedEmbedded || scope.scopedResource === reference;

  return (
    <ReferenceArrayField
      page={1}
      perPage={200}
      reference={reference}
      source={source}
      filter={{ active: true }}
      sortable={sortable}
    >
      <SingleFieldList
        empty={<Typography>None</Typography>}
        linkType={shouldLink ? undefined : false}
      >
        {withColor ? <ColoredChipField /> : <ChipField source="name" size="small" />}
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

const EditReferenceManyField = ({
  withColor,
  showEdit,
  label,
  source,
  reference,
} : {
  withColor?: boolean;
  showEdit: boolean;
  label: string;
  source: string;
  reference: string;
}) => (
  <EditFieldLayout
    source={source}
    label={label}
    showEdit={showEdit}
    inputElement={(
      <ReferenceArrayInput
        page={1}
        perPage={200}
        source={source}
        reference={reference}
        filter={{ active: true }}
      >
        <SelectArrayInput optionText="name" label={false} helperText={false} />
      </ReferenceArrayInput>
    )}
    fieldElement={(
      <ReferenceManyDisplayField
        reference={reference}
        source={source}
        withColor={withColor}
      />
    )}
  />
);

export default EditReferenceManyField;
